import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import Spinner from 'src/components/library/spinner/Spinner';
import { isAppNavigationReadySelector } from 'src/config/navigation.selectors';

const LoadingShell = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: 100vh;
    background-color: ${({ theme }) => theme?.colors?.background?.default || '#ffffff'};
`;

/**
 * Blocks the authenticated app shell until user role and agency context are
 * loaded, preventing a flash of incorrect routes or sidebar items.
 */
const AppNavigationGate = ({ children }) => {
    const isReady = useSelector(isAppNavigationReadySelector);

    if (!isReady) {
        return (
            <LoadingShell role="status" aria-live="polite" aria-label="Loading application navigation">
                <Spinner size="large" />
            </LoadingShell>
        );
    }

    return children;
};

AppNavigationGate.propTypes = {
    children: PropTypes.node.isRequired,
};

export default AppNavigationGate;
